import { h } from 'preact';
import StockDetailsPage from '../stock-details-page';
import { ContainerSize } from '@cube/blocks';
import style from './style';

import { InsiderTransactionsDataTable } from './insider-transactions';
import { GrowthEstimatesDataTable } from './growth-estimates';
import { UpgradeDowngradeDataTable } from './upgrade-downgrade';
import PriceTargetsChart from './price-targets-chart';

export default function AnalystsPanel(props) {
	return (
		<StockDetailsPage showCurrencyIndicator {...props}>
			<InsiderTransactionsDataTable {...props} />
			<GrowthEstimatesDataTable {...props} />
			<div class={style.twoColumns}>
				<ContainerSize>
					<UpgradeDowngradeDataTable {...props} />
					<PriceTargetsChart {...props} />
				</ContainerSize>
			</div>
		</StockDetailsPage>
	);
}
